
import { Vue, Component } from "vue-property-decorator";
import GlobalVariablesInput from "@/oxygen/variables/GlobalVariablesInput.vue";
import { globalStore } from "@/store/store-accessor";
import { Variable } from "@/oxygen/variables/lib/types";
import Icon from "@/components/UI/Icon.vue";
import { breakdanceUndo } from "@/lib/undo/undo";

@Component({
  components: { GlobalVariablesInput, Icon }
})
export default class ManageVariables extends Vue {
  get variables() {
    return globalStore.variables || [];
  }

  updateVariables(variables: Variable[]) {
    breakdanceUndo.transaction(() => {
      globalStore.setVariables(variables);
    }, "Update Variables");
  }
}
